import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "b-filter-editor container-fluid" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("q", null, "Add criterion", -1)
const _hoisted_5 = { class: "col b-filter-controls align-baseline" }
const _hoisted_6 = { class: "row align-baseline" }
const _hoisted_7 = { class: "col ps-0 pe-1 align-baseline" }
const _hoisted_8 = ["onUpdate:modelValue", "onChange"]
const _hoisted_9 = ["value"]
const _hoisted_10 = { class: "col-2 px-0 align-baseline" }
const _hoisted_11 = ["onUpdate:modelValue", "onChange", "disabled"]
const _hoisted_12 = ["value"]
const _hoisted_13 = { class: "col ps-1 pe-0 align-baseline" }
const _hoisted_14 = { class: "col b-filter-actions col-auto align-baseline d-flex align-items-center px-0" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "b-filter-button-bar mt-2" }
const _hoisted_17 = {
  key: 0,
  class: "b-filter-max-count"
}
const _hoisted_18 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.filterCount)
      ? (_openBlock(), _createElementBlock("p", _hoisted_2, "Add up to " + _toDisplayString(_ctx.maxFilterCount) + " search criteria.", 1))
      : _createCommentVNode("", true),
    (!_ctx.filterCount)
      ? (_openBlock(), _createElementBlock("p", _hoisted_3, [
          _createTextVNode("Click "),
          _hoisted_4,
          _createTextVNode(" button to add up to " + _toDisplayString(_ctx.maxFilterCount) + " criteria.", 1)
        ]))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filterOptions.filters.filter(f=> f.property != 'id'), (filter, index) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "row b-filter-criterion align-baseline mb-2",
        key: index
      }, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _withDirectives(_createElementVNode("select", {
                class: "form-select",
                "aria-label": "filter",
                placeholder: "Field Name ",
                "onUpdate:modelValue": ($event: any) => ((filter.property) = $event),
                onChange: ($event: any) => (_ctx.setFilterProperty(filter,$event))
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fieldItems, (item) => {
                  return (_openBlock(), _createElementBlock("option", {
                    value: item.value
                  }, _toDisplayString(item.text), 9, _hoisted_9))
                }), 256))
              ], 40, _hoisted_8), [
                [_vModelSelect, filter.property]
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _withDirectives(_createElementVNode("select", {
                class: "form-select",
                "aria-label": "filter",
                placeholder: "Operation",
                "onUpdate:modelValue": ($event: any) => ((filter.operation) = $event),
                onChange: ($event: any) => (filter.operation = _ctx.getFilterValue($event)),
                disabled: !filter.property
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.operationItems(filter), (item) => {
                  return (_openBlock(), _createElementBlock("option", {
                    value: item.value
                  }, _toDisplayString(item.text), 9, _hoisted_12))
                }), 256))
              ], 40, _hoisted_11), [
                [_vModelSelect, filter.operation]
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.editorComponent(filter)), {
                disabled: !filter.property,
                modelValue: filter.value,
                "onUpdate:modelValue": ($event: any) => ((filter.value) = $event),
                items: _ctx.optionItems(filter),
                onChange: ($event: any) => (_ctx.handleComponentChange($event, filter))
              }, null, 40, ["disabled", "modelValue", "onUpdate:modelValue", "items", "onChange"]))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("button", {
            onClick: _withModifiers(($event: any) => (_ctx.deleteFilter(index)), ["prevent"]),
            class: "btn btn-link text-decoration-none"
          }, " Remove ", 8, _hoisted_15)
        ])
      ]))
    }), 128)),
    _createElementVNode("div", _hoisted_16, [
      (!_ctx.canAddFilter)
        ? (_openBlock(), _createElementBlock("span", _hoisted_17, "You can't add more than " + _toDisplayString(_ctx.maxFilterCount) + " criteria.", 1))
        : _createCommentVNode("", true),
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.addFilter($event)), ["prevent"])),
        disabled: !_ctx.canAddFilter,
        class: "btn btn-success"
      }, "Add Criterion", 8, _hoisted_18)
    ])
  ]))
}